const getApiBaseUrl = () => {
  const mode = import.meta.env.VITE_API_MODE || "local";
  if (mode === "production") {
    return import.meta.env.VITE_PROD_API_URL || import.meta.env.VITE_API_BASE_URL || "";
  }
  return (
    import.meta.env.VITE_LOCAL_API_URL ||
    import.meta.env.VITE_API_BASE_URL ||
    "http://localhost:5000"
  );
};

const API_BASE = getApiBaseUrl().replace(/\/$/, "") + "/api/v1";

export interface IPaginatedMeta {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface IPaginatedResponse<T> {
  data: T[];
  meta?: IPaginatedMeta;
}

export async function apiRequest<T>(
  path: string,
  method: "GET" | "POST" | "PATCH" | "DELETE" = "GET",
  body?: any,
): Promise<T> {
  const isFormData = body instanceof FormData;
  const headers: HeadersInit = {};
  if (!isFormData) {
    headers["Content-Type"] = "application/json";
  }

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: isFormData ? body : body ? JSON.stringify(body) : undefined,
    credentials: "include",
  });

  const text = await res.text();
  let data: any;
  try {
    data = text ? JSON.parse(text) : {};
  } catch (err) {
    throw new Error(
      `API Request failed with status ${res.status}: ${text.substring(0, 100) || res.statusText}`,
    );
  }

  if (!res.ok) {
    throw new Error(data.message || "API Request failed");
  }
  return data && typeof data === "object" && "data" in data ? data.data : data;
}

export async function apiPaginatedRequest<T>(path: string): Promise<IPaginatedResponse<T>> {
  const res = await fetch(`${API_BASE}${path}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  });

  const text = await res.text();
  let json: any;
  try {
    json = text ? JSON.parse(text) : {};
  } catch (err) {
    throw new Error(
      `API Request failed with status ${res.status}: ${text.substring(0, 100) || res.statusText}`,
    );
  }

  if (!res.ok) {
    throw new Error(json.message || "API Request failed");
  }

  return {
    data: Array.isArray(json.data) ? json.data : [],
    meta: json.meta,
  };
}
